export default class SpeciesOfInterest {
  constructor (jsonObj) {
    this.isGenus = jsonObj.isGenus || false
    this.isGenusGroup = jsonObj.isGenusGroup || false
    this.isSpeciesGroup = jsonObj.isSpeciesGroup || false
    this.labelKey = jsonObj.labelKey || 'testKey'
    this.containsGenera = jsonObj.containsGenera || []
    this.visible = jsonObj.visible || Boolean(jsonObj.speciesRelatedToCurrentGenusGroup?.length) || Boolean(jsonObj.speciesRelatedToCurrentSpeciesGroup?.length) || false
    this.speciesRelatedToCurrentGenusGroup = jsonObj.speciesRelatedToCurrentGenusGroup || []
    this.speciesRelatedToCurrentSpeciesGroup = jsonObj.speciesRelatedToCurrentSpeciesGroup || []
  }
}
